import "cookieconsent";
import WebFont from "webfontloader";
import "fg-loadcss/dist/cssrelpreload";
import "~/modules/fontAwesome";
import { dom } from "@fortawesome/fontawesome-svg-core";
import Cookie from "~/modules/cookie";
import "~/../Styles/base/shame.less";
import "~/../Styles/base/typography.less";
import "~/../Styles/components/button.less";
import "~/../Styles/components/copy.less";
import "~/../Styles/components/quote.less";
import "~/../Styles/components/statistic.less";
import "~/../Styles/components/card.less";
import "~/../Styles/layout/overlay.less";

WebFont.load( {
  google: {
    families: [
      "Ubuntu:400,500",
      "Overpass:400,600"
    ]
  }
} );

dom.watch();

document.addEventListener( "DOMContentLoaded", () => {
  window.cookieconsent.initialise( {
    position: "top",
    static: true,
    content: {
      message: `We use cookies on our website to enable some essential functions for you in 
        accordance with our <a href="/privacy-policy">privacy policy</a>. We'd also like your 
        permission to store cookies to help us understand how visitors are using our website 
        so we can improve the experience for them.`,
      deny: "No thanks",
      allow: "That's ok",
      href: "/privacy-policy"
    },
    showLink: false,
    type: "opt-in",
    compliance: {
      "opt-in": "<div class=\"cc-compliance cc-highlight\">{{deny}}{{allow}}</div>"
    },
    onStatusChange () {
      const didConsent = this.hasConsented();
      if ( didConsent ) {
        Cookie.acceptCookies();
      }
      if ( !didConsent ) {
        Cookie.denyCookies();
      }
    },
    onRevokeChoice () {
      const { type } = this.options;
      if ( type === "opt-in" ) {
        Cookie.acceptCookies();
      }
      if ( type === "opt-out" ) {
        Cookie.denyCookies();
      }
    }
  } );
} );
